import React, { useEffect } from 'react';

/**
 * Compact page for the Panda Android Settings WebView card (~240dp tall).
 */
const styles = {
  root: {
    boxSizing: 'border-box',
    minHeight: '100%',
    height: '100%',
    maxHeight: 240,
    margin: 0,
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 10,
    background: 'transparent',
    color: 'var(--text, #ffffff)',
    fontFamily:
      '"Plus Jakarta Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    WebkitTapHighlightColor: 'transparent',
  },
  message: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.4,
    fontWeight: 500,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  button: {
    appearance: 'none',
    border: '1px solid var(--link, #8ab4f8)',
    background: 'transparent',
    color: 'var(--link, #8ab4f8)',
    borderRadius: 999,
    padding: '8px 12px',
    minHeight: 40,
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const DISCORD_URL = 'https://discord.gg/b2hxFNXvWk';

const MESSAGE =
  "We've hit a wall with Google Play — they've forced us to remove Panda's core feature. Rather than water it down, we're moving to a store that actually lets Panda be Panda. Join our Discord with so you don't lose us in the transition";

export default function MobileAppPreview() {
  // Site-wide CSS paints body #0f110d — clear it so Android Surface shows through.
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlBg = html.style.background;
    const prevBodyBg = body.style.background;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.background = 'transparent';
    body.style.background = 'transparent';
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.background = prevHtmlBg;
      body.style.background = prevBodyBg;
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, []);

  return (
    <main className="mobile-app-preview" style={styles.root} role="article">
      <p style={styles.message}>{MESSAGE}</p>
      <div style={styles.actions}>
        <a href={DISCORD_URL} rel="noopener noreferrer" style={styles.button}>
          Join Discord
        </a>
      </div>
    </main>
  );
}
